module.exports = __webpack_public_path__ + "static/media/tire.6f7eb00d.png";